import { Box, Button, List, Typography, useTheme } from "@mui/material";
import { useAppDispatch } from "../../hooks/hooks";
import { LoanPool } from "../../types/loanTypes";
import CowIcon from "../CowIcon";
import EmptyState from "./EmptyState";
import PoolListItem from "./PoolListItem";

const InvestmentListView: React.FC<{
  pools: LoanPool[];
  isMobile: boolean;
  // onInvest: (poolId: string) => void;
}> = ({ pools, isMobile }) => {
  const theme = useTheme();
  const dispatch = useAppDispatch();

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
          p: isMobile ? 1 : 2,
        }}
      >
        <Typography variant="h6">Investment Pools</Typography>
        <Typography variant="body2" color="text.secondary">
          {pools.length} pools available
        </Typography>
      </Box>
      <Box sx={{ p: isMobile ? 1 : 2 }}>
        {pools.length === 0 ? (
          <EmptyState
            icon={<CowIcon fill={theme.palette.text.secondary} size={48} />}
            title="No Investment Pools"
            description="Invest in cattle-backed loans and earn competitive returns"
            action={
              <Button variant="contained" disabled>
                Coming Soon
              </Button>
            }
          />
        ) : (
          <List sx={{ width: "100%" }}>
            {pools.map((pool) => (
              <PoolListItem key={pool.id} pool={pool} isMobile={isMobile} />
            ))}
          </List>
        )}
      </Box>
    </>
  );
};

export default InvestmentListView;
